// #region Define icon names
export const ICON_IDS = {
    DELETE: '#icon-delete',
    UPDATE: '#icon-update',
    CHANGE_PASSWORD: '#icon-change-password',
    RESET_PASSWORD: '#icon-reset-password',
    INVOICE: '#icon-invoice',
    SEARCH: '#icon-search',
    CALENDER: '#icon-calender',
    REGISTER: '#icon-register',
    UNREGISTER: '#icon-unregister',
    PEN_BOOK: '#icon-pen-book',
    PDF: '#icon-pdf',
    EXCEL: '#icon-excel',
    PRINT: '#icon-print',
    LIKE: '#icon-like',
    DISLIKE: '#icon-dislike',
    MESSAGE: '#icon-message',
    TRASH: '#icon-trash'
} as const;

export type IconIdType = (typeof ICON_IDS)[keyof typeof ICON_IDS];
